
<template>

  <div style="width: 100%; height: 100%; position: fixed; z-index: 3; top: 0; left: 0; background: rgba(0,0,0,0.4);">
    <div style="width: 500px; height: 90%; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; border-radius: 20px; box-shadow: 5px 5px 10px black;">
      <div style="width: 100%; height: 50px; line-height: 50px; font-weight: bold; font-size: 20px;">
        New Inventory (Stock In)
      </div>
      <div style="width: 100%; height: calc(100% - 50px); overflow-y: auto; padding-bottom: 20px;">
        <div class="container text-left item-form">
          <div class="row">
            <div class="col-12" style="font-weight: bold; font-size: 18px;">
              {{product.title}}
            </div>
            <div class="col-12" v-if="product.useVariablePrice === true" style="color:#FF5733; font-weight: bold;">
              Weight based product
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <b>Area</b>

              <select v-model="item.area" class="form-control">
                <option value="">Select</option>
                <option v-for="a in areas" :value="a">{{a}}</option>
              </select>
            </div>
            <div class="col-4">
              <b>Location</b>
              <select v-model="item.location" class="form-control">
                <option value="">Select</option>
                <option v-for="a in locations" :value="a">{{a}}</option>
              </select>
            </div>
            <div class="col-4">
              <b>Section</b>
              <select v-model="item.section" class="form-control">
                <option value="">Select</option>
                <option v-for="a in sections" :value="a">{{a}}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <b>Vendor</b>
            </div>
            <div class="col-8">
              <select class="form-control" v-model="item.vendorId" :disabled="item.id > 0">
                <option value="0">Select</option>
                <option v-for="v in vendors" :value="v.id">{{v.title}}</option>
                <option v-for="v in suppliers" :value="v.id">{{v.title}}</option>
              </select>
            </div>
          </div>
          <div class="row" style="padding-bottom: 10px;">
            <div class="col-4">

            </div>
            <div class="col-8">
              <button class="btn" v-bind:class="{'btn-danger': item.noVendorRequired === true}" @click="item.noVendorRequired = true">Agree to No Vendor</button>
              <button class="btn"  v-bind:class="{'btn-primary': item.noVendorRequired === false}" @click="item.noVendorRequired = false">Vendor Required</button>
            </div>
          </div>
          <div class="row" style="border-top: 1px solid #ccc;">
            <div class="col-6">
              <b>Batch Code</b>
            </div>
            <div class="col-6">
              <input class="form-control" v-model="item.batchCode"/>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <b>Expiry Date</b>
            </div>
            <div class="col-6">
              <input type="date" class="form-control" v-model="item.expiryDate"/>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b>Order Number</b>
              <input type="text" v-model="item.orderNumber" class="form-control"/>
            </div>
          </div>
          <template v-if="product.useVariablePrice === true" style="font-size: 15px;">
            <div class="row" style="border-top: 1px solid #ccc; margin-top: 20px;">
              <div class="col-12" style="font-size: 1.2rem; color: #FF5733;">
                <b>Weight information</b>
              </div>
            </div>
            <div class="row">
              <div class="col-6" style="line-height: 31px;">
                <b>Quantity</b> (Number of fillets)
              </div>
              <div class="col-6">
                <input class="form-control" type="number" v-model="item.originalBalance"/>
              </div>
            </div>
            <div class="row">
              <div class="col-6" style="line-height: 31px;">
                <b>Total Weight</b>
              </div>
              <div class="col-6">

                <input class="form-control" type="number" v-model="item.weightFloat" @change="onWeightPriceEntered"/>
              </div>
            </div>
            <div class="row">
              <div class="col-6" style="line-height: 31px;">
                <b>Price per kg</b><span style="color: red;"> (NET excluding VAT)</span>
              </div>
              <div class="col-6">
                <input class="form-control" type="number" v-model="item.pricePerWeightFloat" @change="onValueChanged"/>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="row">
              <div class="col-6">
                <b>Quantity</b>
              </div>
              <div class="col-6">
                <input class="form-control" type="number" v-model="item.originalBalance" @change="onValueChanged"/>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <b>Unit Purchasing Price</b><br/><span style="color: red;">(NET excl VAT)</span>
              </div>
              <div class="col-6">
                <input class="form-control" type="number" v-model="item.unitPriceFloat" @change="onPriceEntered"/>
              </div>
            </div>
          </template>
          <div class="row" style="border-top: 1px solid #ccc; margin-top: 20px;">
            <div class="col-4">
              <b>NET</b>
              <label class="form-control">{{(item.net/100.0).toFixed(2)}}</label>
            </div>
            <div class="col-4">
              <b>VAT (<span v-if="product.taxRate === 0">Zero Rate</span><span v-else>{{product.taxRate/100}}%</span>)</b>
              <label class="form-control">{{(item.vat/100.0).toFixed(2)}}</label>
            </div>
            <div class="col-4">
              <b>GROSS</b>
              <label class="form-control">{{(item.gross/100.0).toFixed(2)}}</label>
            </div>
          </div>




          <div class="row" style="margin-top: 20px;">
            <div class="col-6">
              <button class="btn btn-dark form-control" @click="closeView">Close</button>
            </div>
            <div class="col-6">
              <button class="btn btn-success form-control" @click="submit">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {addNewInventory, getAreaList, getLocationList, getProductInventories, getSectionList} from "../../api/product";
import {showDialog} from "../../api/utils";

export default {
  name: 'InventoryForm',
  props: {
    item: {
      type:Object,
      default: function(){return null;}
    },
    product: {
      type:Object,
      default: function(){return null;}
    },
    vendors: {
      type: Array,
      default: function() { return []}
    },
    suppliers: {
      type: Array,
      default: function() { return []}
    },
    onCreated: {
      type: Function,
      default: null,
    },
    onClose: {
      type: Function,
      default: null,
    }
  },
  data() {
    return {
      areas:getAreaList(),
      locations: getLocationList(),
      sections: getSectionList(),
      inventories:[],
    }
  },
  created() {
  },
  mounted() {
    let areaFound = false;
    for(let i = 0 ;  i < this.$data.areas.length ; i++) {
      if(this.$data.areas[i] === this.item.area) {
        areaFound = true;
        break;
      }
    }
    if(areaFound === false && this.item.area !== null && this.item.area !== '') {
      this.$data.areas.push(this.item.area);
    }

    let locationFound = false;
    for(let i = 0 ;  i < this.$data.locations.length ; i++) {
      if(this.$data.locations[i] === this.item.location) {
        locationFound = true;
        break;
      }
    }
    if(locationFound === false && this.item.location !== null && this.item.location !== '') {
      this.$data.locations.push(this.item.location);
    }

    let sectionFound = false;
    for(let i = 0 ;  i < this.$data.sections.length ; i++) {
      if(this.$data.sections[i] === this.item.section) {
        sectionFound = true;
        break;
      }
    }
    if(sectionFound === false && this.item.section !== null && this.item.section !== '') {
      this.$data.sections.push(this.item.section);
    }
    this.initialise();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    initialise: function() {
      let self = this;
      getProductInventories(this.product.id)
        .then(function(data) {
          if(data.success === true) {
            self.$data.inventories = data.inventories;
          }
        })
        .catch(function(err) {

        })
    },
    dummy: function() {

    },
    onPriceEntered: function() {


      if(this.$data.inventories.length > 0) {
        let message = "Selling price is <span style=\"color:#2fac66; font-weight:bold; font-size: 1.8rem;\">£" + this.product.priceFloat.toFixed(2) + '</span>';
        message += '<br/>Last purchasing price was <span style="color:#27348b; font-weight:bold; font-size: 1.8rem;">£' + this.$data.inventories[this.$data.inventories.length - 1].unitPriceFloat.toFixed(2) + '</span>';
        message += '<br/>New purchasing price is <span style="color:#e7344c; font-weight:bold; font-size: 1.8rem;">£' + parseFloat(this.item.unitPriceFloat).toFixed(2) + '</span>';
        message += '<br/>Is this correct?';

        let self = this;
        this.$modal.show('dialog',{
          title: 'Unit Purchasing Price',
          text: message,
          buttons:[
            {
              title:'No',
              handler:() => {
                this.item.unitPriceFloat = 0.00;
                self.$modal.hide('dialog');
              }
            },
            {
              title:'Yes correct',
              handler:() => {
                self.onValueChanged();
                self.$modal.hide('dialog');
              }
            }
          ]
        })

      }
      this.onValueChanged();
    },

    onWeightPriceEntered: function() {
      if(this.$data.inventories.length > 0) {
        let message = "Selling price per kg is <span style=\"color:#2fac66; font-weight:bold; font-size: 1.8rem;\">£" + this.product.priceFloat;
        message += '<br/>Last purchasing price was <span style="color:#27348b; font-weight:bold; font-size: 1.8rem;">£' + this.$data.inventories[this.$data.inventories.length - 1].pricePerWeightFloat.toFixed(2) + ' per kg</span>';
        message += '<br/>New purchasing price is <span style="color:#e7344c; font-weight:bold; font-size: 1.8rem;">£' + parseFloat(this.item.pricePerWeightFloat).toFixed(2) + ' per kg</span>';
        message += '<br/>Is this correct?';

        let self = this;
        this.$modal.show('dialog',{
          title: 'Unit Purchasing Price',
          text: message,
          buttons:[
            {
              title:'No',
              handler:() => {
                this.item.pricePerWeightFloat = 0.00;
                self.$modal.hide('dialog');
              }
            },
            {
              title:'Yes correct',
              handler:() => {
                self.onValueChanged();
                self.$modal.hide('dialog');
              }
            }
          ]
        })

      }
      this.onValueChanged();
    },
    closeView: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    },
    onValueChanged: function() {
      if(this.product.useVariablePrice === true) {
        console.log("entered weight " + this.item.weightFloat);
        console.log("entered price " + this.item.pricePerWeightFloat);
        this.item.weight = Math.round(this.item.weightFloat * 100);
        this.item.pricePerWeight = Math.round(this.item.pricePerWeightFloat * 100);
        console.log("weight " + this.item.weight + " price " + this.item.pricePerWeight);
        if(this.item.weight > 0) {
          this.item.net = this.item.pricePerWeight*this.item.weight/100;
          if(this.product.taxRate === 0) {
            this.item.vat = 0;
            this.item.gross = this.item.net;
          } else {
            this.item.vat = this.item.net * this.product.taxRate / 10000;
            this.item.gross = this.item.net + this.item.vat;
          }
        } else {
          this.item.net = 0;
          this.item.vat = 0;
          this.item.gross = 0;
        }
      } else {
        if(this.item.unitPriceFloat !== null && this.item.unitPriceFloat !== '') {
          this.item.unitPrice = Math.round(this.item.unitPriceFloat * 100);
        } else {
          this.item.unitPrice = 0;
        }
        if(this.item.originalBalance > 0) {
          this.item.net = this.item.unitPrice*this.item.originalBalance;
          if(this.product.taxRate === 0) {
            this.item.vat = 0;
            this.item.gross = this.item.net;
          } else {
            this.item.vat = this.item.net * this.product.taxRate / 10000;
            this.item.gross = this.item.net + this.item.vat;
          }
        } else {
          this.item.net = 0;
          this.item.vat = 0;
          this.item.gross = 0;
        }
      }


      if(this.item.net > 0) {
        if(this.product.taxRate === 0) {
          this.item.vat = 0;
        }
      }
      // this.item.unitPriceFloat = (this.item.unitPrice/100.0).toFixed(2);
      // if(this.product.taxRate === 0) {
      //   this.item.vat = 0;
      //   this.item.vatFloat = 0;
      //   this.item.gross = this.item.net;
      //   this.item.grossFloat = (this.item.net/100.0).toFixed(2);
      // } else {
      //   this.item.vat = this.item.net * this.product.taxRate / 10000;
      //   this.item.vatFloat = (this.item.net/100.0).toFixed(2);
      //   this.item.gross = this.item.net + this.item.vat;
      //   this.item.grossFloat = (this.item.gross/100.0).toFixed(2);
      // }
      // this.item.unitPrice = 0;
      //
      // if(this.item.originalBalance === null || this.item.originalBalance === '') {
      //   this.item.originalBalance = 0;
      // }
      // if(this.item.originalBalance > 0 && this.item.net > 0) {
      //   this.item.unitPrice = this.item.net / this.item.originalBalance;
      //   this.item.unitPriceFloat = (this.item.unitPrice/100.0).toFixed(2);
      // } else {
      //   this.item.unitPriceFloat = 0.00;
      // }



      this.item.balance = this.item.originalBalance;

    },
    submit: function() {
      this.item.originalBalance = parseInt(this.item.originalBalance);
      this.item.balance = parseInt(this.item.originalBalance);
      this.item.weightBalance = parseInt(this.item.weight);


      if(this.product.useVariablePrice === true) {
        if(this.item.weight === 0) {
          showDialog("Please enter total weight");
          return;
        }
      }

      if(this.item.originalBalance === 0) {
        showDialog("Please enter amount");
        return;
      }
      if(this.item.vendorId == 0 && this.item.noVendorRequired === false) {
        showDialog("", "Please select Vendor.")
        return;
      }
      if(this.item.gross < 0) {
        showDialog("Please enter price (NET)");
        return;
      }
      let self = this;

      // if(true) {
      //   console.log("new create");
      //   console.log(this.item);
      //   return;
      // }
      addNewInventory(this.item)
        .then(function(data) {
          if(data.success === true) {
            if(self.onCreated !== null) {
              self.onCreated(data.item);
            }
            if(self.onClose !== null) {
              self.onClose();
            }
          }
        })
    }
  }
}
</script>

<style scoped>
.item-form .row {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ItemView/InventoryItemForm.vue